module.exports = __webpack_public_path__ + "img/fingerprint.4cb9ed49.png";